__turbopack_context__.v({
  "addedWrapper": "styles-module__dovwDa__addedWrapper",
  "placeholder": "styles-module__dovwDa__placeholder",
});
